module.exports = __webpack_public_path__ + "static/deal_mapper_fill_vouchers-927d343f76bd898cc3bae94bfc477482.gif";